// Importing necessary libraries and components
import React from "react";
// Node.js library to set properties for components
import PropTypes from "prop-types";
// Material-UI core components
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

// Custom styles for the GridContainer component
const styles = {
  grid: {
    margin: "0 -15px !important", // Removes default margin and sets custom margin
    width: "unset", // Allows the grid to take up its natural width
  },
};

// Hook to apply custom styles
const useStyles = makeStyles(styles);

// GridContainer component definition
export default function GridContainer(props) {
  const classes = useStyles(); // Applying custom styles
  const { children, ...rest } = props; // Destructuring props to extract children and other properties

  return (
    // Material-UI Grid container with custom styles and additional props
    <Grid container {...rest} className={classes.grid}>
      {children}
{" "}
{/* Rendering child components */}
    </Grid>
  );
}

// Prop types for the GridContainer component
GridContainer.propTypes = {
  children: PropTypes.node, // Children can be any valid React node
};
